const SWISS = 'swiss';
const HARVEYS = 'harveys';

export default {
    brandDefault:  HARVEYS,

    getBrandFromStoreNumber(storeNumber) {
        // determine brand based on Store Number passed in
        // return brand string

        // Swiss = Location begins with #1
        // Harveys = Location begins with #2

        let firstChar = ("" + storeNumber).substring(0,1)

        if (firstChar == '1') {
            return SWISS
        } else if (firstChar == '2') {
            return HARVEYS
        } else {
            return this.brandDefault;
        }
    },

    orderChannelExclusionList(brand) {
        if (!brand) {
            brand = this.brandDefault;
        }
        
        if (brand == SWISS) {
            return [
                {"channel": "Call Center", "type": "Delivery"},
                {"channel": "UberEats", "type": "*"},
                {"channel": "Skip The Dish", "type": "*"},
                {"channel": "Door Dash", "type": "*"},
                {"emp_num": "21000", "type": "Pick Up"}
            ];
        } else if (brand == HARVEYS) {
            return [
                {"channel": "Harv Call Center", "type": "Delivery"},
                {"channel": "Call Center", "type": "Delivery"},
                {"channel": "*", "type": "Take Out"},
                {"emp_num": "20999", "type": "Pick Up"}
            ];
        } else {
            return [];
        }
    },


    orderPanelDisplay(brand) {
        if (!brand) {
            brand = this.brandDefault;
        }

        if (brand == HARVEYS) {
            return {
                left: [
                    {"channel": "Harv Call Center", "type": "*"},
                    {"channel": "Call Center", "type": "*"}
                ],
                right: [
                    {"channel": "UberEats", "type": "*"},
                    {"channel": "Skip The Dish", "type": "*"},
                    {"channel": "Door Dash", "type": "*"}
                ]
            }
        } else {
            return null;
        }
    },

    showReadyOverrideList() {
        // stores that should display "Ready For Pickup" functionality regardless of Brand defaults
        return [
//            "2999",
            "2314",
            "2784",
            "2781",
            "2778"
        ];
    },

    aggregatorNameRemap(name) {
        if (!name) return '';

        const test = (''+name).toLowerCase();

        if (test.indexOf('uber') >= 0) {
            return 'Uber Eats';
        } else if (test.indexOf('skip') >= 0) {
            return 'Skip the Dishes';
        } else if (test.indexOf('dash') >= 0) {
            return 'DoorDash';
        } else {
            return name;
        }
    }
}


// WEBPACK FOOTER //
// ./src/brandConfig/index.js